import React from 'react';
import { CockpitButton } from 'components/views/atoms/CockpitButton';
import { faWrench } from '@fortawesome/free-solid-svg-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

export type SettingsButtonProps = {
    size?: SizeProp;
    onClick?: () => void;
}

export const SettingsButton = (props: SettingsButtonProps) => {
    return (
        <CockpitButton icon={faWrench} {...props} />
    );
};
